export { CompareAndFavouriteBar } from './compare-and-favourite-bar'
